import script from "./BlockDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockDetail.vue?vue&type=script&setup=true&lang=js"

import "./BlockDetail.vue?vue&type=style&index=0&id=4146a3fa&lang=scss"

const __exports__ = script;

export default __exports__